// Hide '.dr-blog-post .postArchive' elements if the URL contains '/blog/page/{number}/'
document.addEventListener("DOMContentLoaded", function () {

    const match = window.location.pathname.match(/\/blog\/page\/(\d+)\//);

    if (match) {

        // Function to check for the elements and hide them
        function hideElements() {
            const elements = document.querySelectorAll(".dr-blog-posts-wrapper .postArchive");

            if (elements.length > 0) {
                elements.forEach(element => {
                    element.style.display = 'none';
                });
                clearInterval(checkInterval); // Stop checking once elements are found
            }
        }

        // Repeatedly check for elements
        const checkInterval = setInterval(hideElements, 10);

        // Optional: Stop checking if elements never appear
        setTimeout(() => clearInterval(checkInterval), 10);
    } 
});
